import { makeStyles } from '@material-ui/core/styles'

export const boreholeLegendStyle = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    paddingTop: theme.spacing(2)
  },
  layer: {
    display: 'flex'
  },
  color: {
    minWidth: '20px',
    minHeight: '20px',
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.common.black
  },
  description: {
    fontSize: '0.7rem'
  }
}))
